import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=42e24952&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"
import style0 from "./Sidebar.vue?vue&type=style&index=0&id=42e24952&prod&lang=css"
import style1 from "./Sidebar.vue?vue&type=style&index=1&id=42e24952&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e24952",
  null
  
)

export default component.exports